import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Box, Button, Text } from '@rsos/base-components';
import { setSelectedCallerID } from '@rsos/reduxDataStore';
import type {
  EmergencyCall,
  EmergencyCallLocation,
  LocationType,
} from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCalls.types';
import { getMostRecentLoc } from '@rsos/utils/getMostRecentLoc';
import { getToastButtonText, getToastIcon, getToastMessage } from './helpers';

const ViewButton = styled(Button).attrs({
  btnType: 'secondary',
  noMargin: true,
})`
  height: 28px;
`;

interface EmergencyCallsToastProps {
  emergencyCall: EmergencyCall;
  locationType: LocationType;
  handleButtonClick?: () => void;
}

const EmergencyCallsToast = ({
  emergencyCall,
  locationType,
  handleButtonClick,
}: EmergencyCallsToastProps) => {
  const dispatch = useDispatch();
  const mostRecentLocation = getMostRecentLoc(
    emergencyCall,
  ) as EmergencyCallLocation;
  const icon = getToastIcon(locationType);
  const message = getToastMessage(mostRecentLocation);

  const handleViewClick = () => {
    dispatch(setSelectedCallerID(mostRecentLocation.caller_id));
  };

  return (
    <Box
      horizontal
      align="center"
      justify="space-between"
      data-name="emergency-calls-toast"
    >
      <Box horizontal mr="12px" align="center">
        <Box mr="12px">{icon}</Box>
        <Text>{message}</Text>
      </Box>
      <ViewButton
        data-name="emergency-calls-toast-view-button"
        mr="16px"
        onClick={handleButtonClick || handleViewClick}
      >
        {getToastButtonText(mostRecentLocation)}
      </ViewButton>
    </Box>
  );
};

export default EmergencyCallsToast;
